import React from "react";
import clsx from "clsx";

import {DeviceStatus, STATUS_LABELS} from "./buildTree";

import classes from "./DevicesExplorer.module.scss";

const STATUS_CLASS: Record<DeviceStatus, string> = {
    healthy: classes.statusChipHealthy,
    offline: classes.statusChipOffline,
    warning: classes.statusChipWarning,
    alarm: classes.statusChipAlarm,
};

interface StatusChipProps {
    status: DeviceStatus;
    count: number;
    showLabel?: boolean;
    onClick?: () => void;
    active?: boolean;
    dimmed?: boolean;
}

const StatusChip: React.FC<StatusChipProps> = ({status, count, showLabel, onClick, active, dimmed}) => {
    if (!count) {
        return null;
    }

    const clickable = !!onClick;
    const title = clickable
        ? `${active ? "Clear filter" : "Show only"} ${STATUS_LABELS[status]} (${count})`
        : `${count} ${STATUS_LABELS[status]}`;

    return (
        <span
            className={clsx(
                classes.statusChip,
                STATUS_CLASS[status],
                clickable && classes.statusChipClickable,
                active && classes.statusChipActive,
                dimmed && classes.statusChipDimmed,
            )}
            title={title}
            onClick={onClick}
            role={clickable ? "button" : undefined}
        >
            <span className={classes.statusDot}/>
            {count}
            {showLabel && <span className={classes.statusChipLabel}>{STATUS_LABELS[status]}</span>}
        </span>
    );
};

export default StatusChip;
